import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
// material
import { Grid, Card, Stack, Typography, Divider, Switch } from "@mui/material";
// hooks
import useAuth from "../../../hooks/useAuth";
import { useState } from "react";
// utils

const DETAILS = [
  [
    {
      title: "Direct Booking Payment Charges",
      subtitle:
        "Enable this option to let customers cover transaction fees when paying via POS or bank transfer during manual bookings.",
      value: "direct_booking_charges",
    },
    {
      title: "Payment Notifications",
      subtitle:
        "Get instantly notified via your preferred channel whenever a new payment is received for a booking or manual payment is received.",
      value: "payment_notifications",
    },
  ],
  [
    {
      title: "Auto-Renew Subscription",
      subtitle:
        "When enabled, your subscription will automatically renew at the end of each billing cycle to ensure uninterrupted service",
      value: "auto_renew_subscription",
    },
  ],
  [
    {
      title: "Get Booking Notifications",
      subtitle:
        "Receive instant alerts via Email, SMS, or WhatsApp whenever a new booking is made.",
      value: "booking_notifications",
    },
    {
      title: "Daily Booking Summary Reports",
      subtitle:
        "Receive end-of-day reports for all your listings, including both Afritas bookings and manual bookings added by you or your team.",
      value: "daily_booking_summary",
    },
    {
      title: "Monthly Performance Reports",
      subtitle:
        "Access detailed monthly reports for all your listings, including both Afritas-generated bookings and host-added bookings.",
      value: "monthly_performance_reports",
    },
  ],
];

const CustomSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      left: 12,
    },
    "&::after": {
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export default function Preferences() {
  const { enqueueSnackbar } = useSnackbar();
  const { user, updateSettings } = useAuth();
  const [values, setValues] = useState(
    JSON.parse((user && user.user && user.user.notifications) || "{}")
  );
  const handleSave = async (selected, value) => {
    try {
      await updateSettings({ key: selected, value }, "notification");
      //   enqueueSnackbar("Settings updated successfully!", {
      //     variant: "success",
      //   });
    } catch (err) {
      enqueueSnackbar(err.message || err, {
        variant: "error",
      });
    }
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Stack spacing={4}>
          <Stack spacing={{ md: 5, xs: 2 }}>
            {DETAILS.map((items, index) => (
              <Card
                key={index}
                sx={{
                  py: 1,
                  px: 3,
                  boxShadow: {
                    md: "-1px 1px 11.4px 0px rgba(0, 0, 0, 0.08)",
                    xs: "none",
                  },
                  borderRadius: 1,
                }}
              >
                <Stack spacing={3} divider={<Divider flexItem />}>
                  {items.map((item, i) => (
                    <Stack
                      key={i}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Stack spacing={0.5}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: { md: "#000", xs: "rgba(64, 60, 60, 1)" },
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { md: 14, xs: 12 },
                            fontWeight: 300,
                            color: {
                              md: "rgba(98, 98, 98, 1)",
                              xs: "rgba(95, 95, 95, 1)",
                            },
                          }}
                        >
                          {item.subtitle}
                        </Typography>
                      </Stack>
                      <CustomSwitch
                        checked={
                          Boolean(values[item.value]) &&
                          parseInt(values[item.value].enabled || 0, 10) === 1
                        }
                        onChange={(e) => {
                          setValues((prev) => ({
                            ...prev,
                            [item.value]: { enabled: e.target.checked ? 1 : 0 },
                          }));
                          handleSave(item.value, {
                            enabled: e.target.checked ? 1 : 0,
                          });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Stack>
                  ))}
                </Stack>
              </Card>
            ))}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}
